define('AwaLabs.ItemAvailability', [
    'Cart.Lines.View',
    'ItemAvailability.View'
], function ItemAvailabilityFn(
    CartLinesView,
    ItemAvailabilityView
) {
    'use strict';

    return {
        mountToApp: function mountToApp() {
            CartLinesView.addChildViews({
                'ItemAvailability.View': function wrapperFunction(options) {
                    return function fnWrap() {
                        return new ItemAvailabilityView({
                            model: options.model
                        });
                    };
                }
            });
        }
    };
});
